import { useCallback } from 'react'
import WindowIpcRenderer from '@renderer/ipc/WindowIpc.renderer'
import { trackOpenFeedback } from '@renderer/components/feedback/use-open-feedback'
import { useSetSidepanelState } from '@renderer/overlay/atoms'
import { isBrowserRuntime, navigateToHighlightRoute } from '@renderer/browser/browser-utils'
import { feedbackSettingsRoute } from '@shared/settings/settings-deeplink'
import { useSidepanelLocked } from '../atoms'

/**
 * The support widget misbehaves in the click-through overlay, so sidepanel
 * feedback opens in the settings window's widget instead.
 */
export function useOpenFeedbackInSettings(source: string) {
  const setSidepanelState = useSetSidepanelState()
  const locked = useSidepanelLocked()

  return useCallback(() => {
    trackOpenFeedback(source)
    if (isBrowserRuntime()) {
      navigateToHighlightRoute(feedbackSettingsRoute())
      return
    }
    if (!locked) {
      setSidepanelState('hidden')
    }
    WindowIpcRenderer.openSettingsWindow(feedbackSettingsRoute()).catch((error) => {
      console.error('Failed to open feedback in settings:', error)
    })
  }, [locked, setSidepanelState, source])
}
